import React from 'react';
import {isArray} from 'lodash';
import TextFormGroup from './form-components/TextFormGroup';
import DropdownFormGroup from './form-components/DropdownFormGroup';
import TextareaFormGroup from './form-components/TextareaFormGroup';
import {isPrincipia} from './utils/accountRoles';
import DecimalFormGroup from './form-components/DecimalFormGroup';

const AdditionalContractDetailsForm = ({data, onChange}) => {
    return (
        <div>
            <div className="row">
                <div className="col-sm-offset-4 col-sm-8">
                    <legend>{window.__js_contracts.additional_contract_details}</legend>
                </div>
            </div>

            <TextFormGroup
                label={window.__js_contracts.rfq_code_field}
                name="rfq_code"
                value={data.rfq_code}
                onChange={(value) => onChange('rfq_code', value)}
            />

            <DropdownFormGroup
                label={window.__js_contracts.payment_term_field}
                name="payment_term"
                value={data.payment_term}
                onChange={(value) => onChange('payment_term', value)}
                options={data.payment_terms || []}
            />

            <DropdownFormGroup
                label={window.__js_contracts.rfq_process_field}
                name="rfq_process"
                value={data.rfq_process}
                onChange={(value) => onChange('rfq_process', value)}
                options={data.rfq_processes || []}
            />

            <DropdownFormGroup
                label={window.__js_contracts.department_field}
                name="department_id"
                value={data.department_id}
                onChange={(value) => onChange('department_id', value)}
                options={data.departments || []}
            />

            <DropdownFormGroup
                label={window.__js_contracts.co_scope_field}
                name="co_scope"
                value={data.co_scope}
                onChange={(value) => onChange('co_scope', value)}
                options={data.co_scopes || []}
            />

            <TextareaFormGroup
                label={window.__js_contracts.notes_field}
                name="notes"
                value={data.notes}
                onChange={(value) => onChange('notes', value)}
            />

            {
                isPrincipia()
                    ? <DropdownFormGroup
                        label={window.__js_contracts.mg_description}
                        name="mg_description_id"
                        value={data.mg_description_id}
                        onChange={(value) => onChange('mg_description_id', value)}
                        options={data.mg_descriptions || []}
                    />
                    : null
            }

            {
                isArray(data.account_organizations) && data.account_organizations.length > 0
                    ? <DropdownFormGroup
                        label={window.__js_contracts.account_organization}
                        name="account_organization_id"
                        value={data.account_organization_id}
                        onChange={(value) => onChange('account_organization_id', value)}
                        options={data.account_organizations || []}
                        isRequired={true}
                    />
                    : null
            }

            <TextFormGroup
                label={window.__js_contracts.sap_contract_number}
                name="sap_contract_number"
                value={data.sap_contract_number || ''}
                onChange={(value) => onChange('sap_contract_number', value)}
            />

            <DecimalFormGroup
                label={window.__js_bid_reviews.savings_amount}
                name="savings_amount_comma"
                value={data.savings_amount || ''}
                onChange={(value) => onChange('savings_amount', value)}
            />

            <DecimalFormGroup
                label={window.__js_bid_reviews.savings_percentage}
                name="savings_percentage_comma"
                value={data.savings_percentage || ''}
                onChange={(value) => onChange('savings_percentage', value)}
            />
        </div>
    );
}

export default AdditionalContractDetailsForm;